import { MAX_INT_CONST } from 'helpers/global.const.helper';

export default function flectionNumeral(count: number, words: string[], textOnly = false): string {
    // words[0] - komentarz

    // words[1] - komentarze

    // words[2] - komentarzy
    let text;

    if (count % 100 < 20) {
        switch (count % 100) {
            case 0:
                text = words[2];

                break;
            case 1:
                text = words[0];

                break;
            case 2:
            case 3:
            case 4:
                text = words[1];

                break;
            default:
                text = words[2];
        }
    } else {
        const lastDigit = Number(count.toString().slice(-1));

        text = [2, 3, 4].includes(lastDigit) ? words[1] : words[2];
    }

    return textOnly ? text : `${count} ${text}`;
}

export function isProductIdNumberValid(number: number): boolean {
    return (number > 0) && (number < MAX_INT_CONST) && !isNaN(number) && isFinite(number);
}

export function roundToNearest(value: number, step: number): number {
    return Math.round(value / step) * step;
}
